import { FC, useEffect, useState } from 'react'
import { LoadingOverlay } from 'react-common'
import debounce from 'lodash/debounce'
import { useAppSelector } from '@/store/hooks'

export const Loading: FC = () => {
  const blockingOperations = useAppSelector((state) => state.loading.blockingOperations)

  const [debouncedLoading, setDebouncedLoading] = useState<boolean>(false)

  const debouncedUpdate = debounce((loading: boolean) => {
    setDebouncedLoading(loading)
  }, 300)

  useEffect(() => {
    const isLoading = blockingOperations > 0
    debouncedUpdate(isLoading)

    return debouncedUpdate.cancel
  }, [blockingOperations, debouncedUpdate])

  return <LoadingOverlay isLoading={debouncedLoading} />
}
